define(["require", "exports", "jquery"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var fileCount = 1;
    $(function () {
        /**
         * File Browser Hack for Bootstrap Forms
         */
        $(document).on('click', '.browse', function () {
            var file = $(this).parent().parent().parent().find('.file');
            file.trigger('click');
        });
        $(document).on('change', '.file', function () {
            // @ts-ignore
            $(this).parent().find('.form-control').val($(this).val().replace(/C:\\fakepath\\/i, ''));
        });
        $('#addfile').on('click', function () {
            if (fileCount <= 5) {
                fileCount++;
                $('#file' + fileCount).show();
                if (fileCount === 5) {
                    // @ts-ignore
                    $('#addfile').attr('disabled', true);
                }
            }
        });
        /**
         * Check File Size
         */
        $(function () {
            $('form').submit(function () {
                var isOk = true;
                // @ts-ignore
                $('input[type=file][data-max-size]').each(function (index, element) {
                    // @ts-ignore
                    if (typeof this.files[0] !== 'undefined') {
                        // @ts-ignore
                        var maxSize = parseInt($(this).attr('data-max-size'), 10), size = this.files[0].size;
                        isOk = maxSize > size;
                        if (isOk == false) {
                            var alertText = $('#alertText_' + (index + 1)).html();
                            alert(alertText);
                        }
                        return isOk;
                    }
                });
                return isOk;
            });
        });
    });
});
